<template>
	<el-container class="wallet-admin">
		<el-header class="toolbar" height="60px">
			<el-input v-model="keyword" placeholder="用户名/昵称/TRON地址" size="small" style="width:220px"
				clearable @keyup.enter.native="loadList"></el-input>
			<el-button size="small" type="primary" icon="el-icon-search" @click="loadList">查询</el-button>
			<div class="stats-row" v-if="stats">
				<el-tag size="small">钱包: {{ stats.walletCount }}</el-tag>
				<el-tag size="small" type="success">托管: {{ stats.managedCount }}</el-tag>
				<el-tag size="small" type="danger">冻结: {{ stats.frozenCount }}</el-tag>
				<el-tag size="small">订单: {{ stats.orderCount }}</el-tag>
				<el-tag size="small" type="success">已确认: {{ stats.confirmedOrderCount }}</el-tag>
				<el-tag size="small" type="warning">到账: {{ stats.txCount }}</el-tag>
			</div>
		</el-header>
		<el-main>
			<el-tabs v-model="activeTab">
				<el-tab-pane label="钱包列表" name="wallets">
					<el-table :data="records" size="small" v-loading="loading" border>
						<el-table-column label="ID" prop="userId" width="60"></el-table-column>
						<el-table-column label="用户名" prop="userName" width="130"></el-table-column>
						<el-table-column label="昵称" prop="nickName" width="130"></el-table-column>
						<el-table-column label="TRON地址" prop="tronAddress" show-overflow-tooltip></el-table-column>
						<el-table-column label="模式" width="100">
							<template slot-scope="s">
								<el-tag v-if="s.row.mode === 1" size="mini" type="success">托管</el-tag>
								<el-tag v-else size="mini" type="info">只读</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="状态" width="90">
							<template slot-scope="s">
								<el-tag v-if="s.row.frozen" size="mini" type="danger">已冻结</el-tag>
								<el-tag v-else size="mini">正常</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="绑定时间" width="160">
							<template slot-scope="s">{{ fmtTime(s.row.bindTime) }}</template>
						</el-table-column>
						<el-table-column label="操作" width="200" fixed="right">
							<template slot-scope="s">
								<el-button v-if="!s.row.frozen" size="mini" type="danger" plain
									@click="onFreeze(s.row, true)">冻结</el-button>
								<el-button v-else size="mini" type="success" plain
									@click="onFreeze(s.row, false)">解冻</el-button>
								<el-button size="mini" type="danger" @click="onDeleteWallet(s.row)">删除数据</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination small layout="prev, pager, next" :total="total" :page-size="pageSize"
						:current-page.sync="pageNo" @current-change="loadList"
						style="margin-top:12px;text-align:right"></el-pagination>
				</el-tab-pane>
				<el-tab-pane label="转账订单" name="orders">
					<el-table :data="orderRecords" size="small" v-loading="orderLoading" border>
						<el-table-column label="订单号" prop="orderNo" width="180" show-overflow-tooltip></el-table-column>
						<el-table-column label="用户ID" prop="userId" width="70"></el-table-column>
						<el-table-column label="币种" prop="token" width="80"></el-table-column>
						<el-table-column label="金额" prop="amount" width="110"></el-table-column>
						<el-table-column label="收款地址" prop="toAddress" show-overflow-tooltip></el-table-column>
						<el-table-column label="状态" width="90">
							<template slot-scope="s">
								<el-tag v-if="s.row.status === 2" size="mini" type="success">已确认</el-tag>
								<el-tag v-else-if="s.row.status === 1" size="mini">广播成功</el-tag>
								<el-tag v-else-if="s.row.status === 3" size="mini" type="danger">失败</el-tag>
								<el-tag v-else size="mini" type="warning">广播中</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="时间" width="160">
							<template slot-scope="s">{{ fmtTime(s.row.createdTime) }}</template>
						</el-table-column>
					</el-table>
					<el-pagination small layout="prev, pager, next" :total="orderTotal" :page-size="pageSize"
						:current-page.sync="orderPageNo" @current-change="loadOrders"
						style="margin-top:12px;text-align:right"></el-pagination>
				</el-tab-pane>
			</el-tabs>
		</el-main>
	</el-container>
</template>

<script>
export default {
	name: "walletAdmin",
	data() {
		return {
			loading: false,
			keyword: '',
			records: [],
			total: 0,
			pageNo: 1,
			pageSize: 10,
			stats: null,
			activeTab: 'wallets',
			orderLoading: false,
			orderRecords: [],
			orderTotal: 0,
			orderPageNo: 1
		}
	},
	watch: {
		activeTab(tab) {
			if (tab === 'orders' && this.orderRecords.length === 0) {
				this.loadOrders();
			}
		}
	},
	created() {
		this.loadList();
		this.loadStats();
	},
	methods: {
		loadOrders() {
			this.orderLoading = true;
			this.$http({
				url: "/admin/wallet/orders",
				method: "get",
				params: {
					pageNo: this.orderPageNo,
					pageSize: this.pageSize
				}
			}).then((data) => {
				this.orderRecords = data.records || [];
				this.orderTotal = data.total || 0;
			}).catch(() => {}).finally(() => {
				this.orderLoading = false;
			});
		},
		onDeleteWallet(row) {
			const managed = row.mode === 1;
			this.$confirm(
				`确认删除用户 ${row.userName} 的钱包数据？` +
				(managed ? '该钱包为托管钱包,删除后密钥密文将被销毁且不可恢复!' : '该钱包为只读绑定,删除后需重新绑定。') +
				'关联的到账流水将一并清理。',
				'删除钱包数据', { type: 'error', confirmButtonText: '确认删除' }).then(() => {
				this.$http({
					url: `/admin/wallet/${row.id}`,
					method: "delete"
				}).then(() => {
					this.$message.success('钱包数据已删除(密文已销毁)');
					this.loadList();
					this.loadStats();
				}).catch(() => {});
			}).catch(() => {});
		},
		loadList() {
			this.loading = true;
			this.$http({
				url: "/admin/wallet/list",
				method: "get",
				params: {
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					keyword: this.keyword || undefined
				}
			}).then((data) => {
				this.records = data.records || [];
				this.total = data.total || 0;
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		loadStats() {
			this.$http({
				url: "/admin/wallet/stats",
				method: "get"
			}).then((data) => {
				this.stats = data;
			}).catch(() => {});
		},
		onFreeze(row, freeze) {
			const tip = freeze
				? `冻结用户 ${row.userName} 的钱包?冻结后将禁止其链上转账`
				: `解冻用户 ${row.userName} 的钱包?`;
			this.$confirm(tip, '提示', { type: freeze ? 'warning' : 'info' }).then(() => {
				this.$http({
					url: `/admin/wallet/freeze/${row.userId}`,
					method: "post",
					params: { freeze }
				}).then(() => {
					this.$message.success(freeze ? '已冻结' : '已解冻');
					this.loadList();
					this.loadStats();
				}).catch(() => {});
			}).catch(() => {});
		},
		fmtTime(t) {
			return (t || '').replace('T', ' ').slice(0, 19);
		}
	}
}
</script>

<style lang="scss" scoped>
.wallet-admin {
	background-color: white;
	padding: 10px;

	.toolbar {
		display: flex;
		align-items: center;
		gap: 10px;

		.stats-row {
			margin-left: auto;
			display: flex;
			gap: 8px;
		}
	}
}
</style>
